import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Button/sgds-button";
import { register } from "../../utils/ce-registry";

register("sgds-button", Component);

export default createComponent({
  react: React,
  tagName: "sgds-button",
  elementClass: Component,
  events: {
    onSgdsBlur: "sgds-blur",
    onSgdsFocus: "sgds-focus"
  }
});
